// Customer.jsx
import React from 'react';
import { Paper } from '@mantine/core';
import CustomerTabSet from './CustomerTabSet';
 
const Customer = () => {
    return (
        <Paper>
            <CustomerTabSet />
        </Paper>
    );
};

export default Customer;
